import type { SVGProps } from "react";

export function Reset(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.9997 8.7291C12.9997 11.4894 10.7621 13.727 8.0018 13.727C5.24154 13.727 3.00391 11.4894 3.00391 8.7291C3.00391 5.96884 5.24154 3.7312 8.0018 3.7312H11.6669M11.6669 3.7312L9.99924 2M11.6669 3.7312L10.0001 5.66667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
